import { appDefinitions, BU, PILLAR } from './app-definitions';

export const name = 'landingContent';
export default function landingContent(
) {
  //noinspection BadExpressionStatementJS
  'ngInject';

  const directive = {
    restrict: 'EA',
    scope: {
      bu: '=',
      locale: '=',
    },
    template: require('./landing-content.jade'),
    link: landingContentLink,
    controller: landingContentController,
    controllerAs: 'vm',
    bindToController: true,
  };

  return directive;


  //////////////////////
  // Private functions

  function landingContentLink(scope, element, attrs) {
  }

  /** @ngInject */
  function landingContentController(
    rnClient,
    rnLocale,
    rnLocalStorage,
    $gzEULA,
    $gzAnalytics,
    $translate,
    $rootScope,
    $window,
    $timeout
  ) {
    // Constants
    // Variables
    let currentLocale;
    let isIconUX = false;
    let enterAppCount = 0;
    let sentScrollEvent = false;

    // View Model
    let vm = this;
    vm.loading = true;
    vm.signInData = {};
    vm.categories = [
      {
        id: 'optimize',
        icon: 'https://cdn.printos.com/images/signin/landing/Optimize.svg',
        displayKey: 'register.register.Pillar_Optimize_Section',
        apps: [],
        filteredAppCount: 0,
      },
      {
        id: 'automate',
        icon: 'https://cdn.printos.com/images/signin/landing/Automate.svg',
        displayKey: 'register.register.Pillar_Automate_Section',
        apps: [],
        filteredAppCount: 0,
      },
      {
        id: 'grow',
        icon: 'https://cdn.printos.com/images/signin/landing/Grow.svg',
        displayKey: 'register.register.Pillar_Grow_Section',
        apps: [],
        filteredAppCount: 0,
      },
    ];

    vm.selectedBUs = [];
    vm.localeChanged = localeChanged;
    vm.openTerms = openTerms;
    vm.scroll = scroll;
    vm.selectBU = selectBU;
    vm.linkClicked = linkClicked;
    vm.leaveApp = leaveApp;
    vm.enterApp = enterApp;

    activate();
    return;


    ///////////////////////////////////////////////////////////
    // Activate
    function activate() {
      return rnClient.getConfig().then(cc => {
        // isIconUX = cc.features.includes('ux-app-icons');
        vm.supportURL = '#/support?fromState=signin&expanded=false';
        if (vm.bu) {
          vm.supportURL += `&bu=${vm.bu}`;
        }

        initApplications();
        filterApplications();

        initScrollListeners();

        $window.addEventListener('resize', event => {
          let myContainer = $window.document.getElementById('parallax-container');
          if (myContainer) {
            $rootScope.$applyAsync(() => {
              vm.showScrollButton = myContainer.scrollHeight > myContainer.clientHeight;
              vm.atTop = myContainer.scrollTop === 0;
              updateWelcomePositioning();
            });
          }
        });

      })
        .finally(() => {
        vm.loading = false;
      });
    }

    function initScrollListeners() {
      if (vm.bu === '3D') {
        return;
      }

      let myContainer = $window.document.getElementById('parallax-container');
      if (!myContainer) {
        $timeout(initScrollListeners, 500);
        return;
      }

      vm.showScrollButton = myContainer.scrollHeight > myContainer.clientHeight;
      vm.atTop = myContainer.scrollTop === 0;
      updateWelcomePositioning();
      myContainer.addEventListener('scroll', event => {
        if (!sentScrollEvent && myContainer.scrollTop > 100) {
          $gzAnalytics.event('Scroll: user scrolled down', {category:'landing-page'});
          sentScrollEvent = true;
        }
        $rootScope.$applyAsync(updateWelcomePositioning);
      });
    }

    function initApplications() {
      appDefinitions.forEach(def => {
        // def.name = $translate.instant(`register.register.${def.id}_Name`);
        // def.desc = $translate.instant(`register.register.${def.id}_Desc`);
        let iconDir = isIconUX ? 'icons2' : 'icons';
        def.icon = `https://cdn.printos.com/images/application/${iconDir}/${def.appId}.svg`;
        def.show = true;
        def.hover = false;
      });

      let sortedDefinitions = appDefinitions.sort((a,b) => {
        return b.priority - a.priority;
      });

      let optApps = sortedDefinitions.filter(def => {
        return def.pillar === PILLAR.Optimize;
      });

      let autoApps = sortedDefinitions.filter(def => {
        return def.pillar === PILLAR.Automate;
      });

      let growApps = sortedDefinitions.filter(def => {
        return def.pillar === PILLAR.Grow;
      });

      vm.categories[0].apps = orderApps(optApps);
      vm.categories[1].apps = orderApps(autoApps);
      vm.categories[2].apps = orderApps(growApps);
    }

    function orderApps(apps) {
      let orderedApps = [];
      for (let i = 0; i < apps.length; i++) {
        if (i % 2) {
          orderedApps.unshift(apps[i]);
        }
        else {
          orderedApps.push(apps[i]);
        }
      }

      return orderedApps;
    }

    function updateWelcomePositioning() {
      let myContainer = $window.document.getElementById('parallax-container');
      let test = $window.document.getElementById('caption-1');
      let tRect = test.getBoundingClientRect();
      let pRect = test.parentElement.getBoundingClientRect();
      let heightOnScreen = pRect.height - myContainer.scrollTop;
      let bottomWhiteSpace = (heightOnScreen - tRect.height) * 0.6;
      test.style.bottom = bottomWhiteSpace < 64 ? '64px' : bottomWhiteSpace + 'px';
      vm.atTop = myContainer.scrollTop === 0;
    }


    ///////////////////////////////////////////////////////////
    // View Model
    function localeChanged() {
      currentLocale = vm.signInData.locale;
      vm.locale = currentLocale;
      $translate.use(currentLocale.value);
      rnLocale.setLocalePreference(currentLocale);

      // Temporarily commenting this out until we figure out a path forward with the following issue. This
      // particular event ('locale dropdown - selected') is the #1 reported event in the 'register' category
      // due to the fact that this function is called by Material Design during each page refresh, sign-in,
      // and sign-out. It does not reflect actual usage by the user. However, we would like to know how often
      // this is used.
      //
      //$gzAnalytics.eventSelect('locale dropdown', {label: currentLocale.value});
    }

    function openTerms() {
      $gzEULA.show();
    }

    function scroll(event) {
      event.preventDefault();
      let myContainer = $window.document.getElementById('parallax-container');
      if (vm.atTop) {
        $gzAnalytics.event('Click: scroll Down button', {category:'landing-page'});
        myContainer.scrollTo({top: myContainer.scrollHeight, behavior: 'smooth'});
      }
      else {
        $gzAnalytics.event('Click: scroll Up button', {category:'landing-page'});
        myContainer.scrollTo({top: 0, behavior: 'smooth'});
      }
    }

    function selectBU(bu) {
      if (vm.selectedBUs.includes(bu)) {
        vm.selectedBUs.splice(vm.selectedBUs.indexOf(bu), 1);
      }
      else {
        vm.selectedBUs.push(bu);
        $gzAnalytics.event(`Click: Application Family {bu}`, {category:'landing-page'});
      }
      filterApplications();
    }

    function leaveApp(app) {
      app.hover = false;
      //$window.dispatchEvent(new window.CustomEvent('gz-youtube-command-stop', {detail: { playerId: 'gz-carousel' }} ));
    }

    function enterApp(app) {
      enterAppCount++;
      switch (enterAppCount) {
        case 25:
          $gzAnalytics.event('Accordion: love interaction', {category:'landing-page'});
          break;
        case 10:
          $gzAnalytics.event('Accordion: engaged interaction', {category:'landing-page'});
          break;
        case 5:
          $gzAnalytics.event('Accordion: curious interaction', {category:'landing-page'});
          break;
        case 1:
          $gzAnalytics.event('Accordion: interaction', {category:'landing-page'});
          break;
      }

      app.hover = true;
      let api = _.get(app, 'content.api');
      if (!api) {
        return;
      }
      api.setPage(0);
    }

    function linkClicked(app) {
      if (app.learn.link) {
        $window.open(app.learn.link, '_blank');
      }
    }

    ///////////////////////////////////////////////////////////
    // Helpers
    function filterApplications() {
      vm.loadingContent = true;
      $rootScope.$applyAsync(() => {
        vm.categories.forEach(category => {
          filterCategory(category);
        });
        vm.loadingContent = false;
      });
    }

    function filterCategory(category) {
      category.filteredAppCount = 0;
      category.apps.forEach(def => {
        def.show = isSelectedBusMatch(def);
        if (def.show) {
          if (def.content) {
            def.filteredContent = def.content.filter(content => {
              if (!content.businessUnits) {
                return true;
              }

              return isSelectedBusMatch(content);
            });
          }

          category.filteredAppCount++;
        }
      });
    }

    function isSelectedBusMatch(app) {
      for (let i = 0; i < vm.selectedBUs.length; i++) {
        if (app.businessUnits.includes(vm.selectedBUs[i])) {
          return true;
        }
      }

      return false;
    }
  }
}



// WEBPACK FOOTER //
// ./components/landing-content/landing-content.directive.js